import { isArray, isFunction } from "@visactor/vutils";

import { DEFAULT_DATA_INDEX, DEFAULT_DATA_SERIES_FIELD } from "../../constant/data";

const resolveOptionValue = option => isFunction(option) ? option() : option;

export const correlationCenter = (data, options) => {
    if (!data || !isArray(data)) return [];
    const keyword = resolveOptionValue(options.keyword), categoryField = resolveOptionValue(options.categoryField), nodeInfo = data[0].latestData[0];
    return {
        [categoryField]: keyword,
        [DEFAULT_DATA_INDEX]: null == nodeInfo ? void 0 : nodeInfo[DEFAULT_DATA_INDEX],
        [DEFAULT_DATA_SERIES_FIELD]: null == nodeInfo ? void 0 : nodeInfo[DEFAULT_DATA_SERIES_FIELD]
    };
};
//# sourceMappingURL=correlation-center.js.map
